import {Component, ElementRef, Input, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {ClickOutsideDirective} from '../../directives/click-outside.directive';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-dropdown-type',
  templateUrl: './dropdown-type.component.html',
  styleUrls: ['./dropdown-type.component.less']
})
export class DropdownTypeComponent implements OnInit {
  @Input() dropdownLabel: string;
  @Input() showAny: boolean;
  @Input() fieldName: string;
  @Input() colorStyle: string;
  @Input() sourceList: any[];
  @Input() upperDropdown: boolean;
  @Input() disabled: boolean = false;
  @Input() answerType: string;

  @Output() userChoice: EventEmitter<string> = new EventEmitter<string>();

  blobUrl: string;
  imageId: string;
  dropdown: boolean;
  text:string[];
  yesNoLbl: string;
  compareDates: any[];
  compareOther: any[];
  isFilterResponse: boolean;
  constructor() { }

  ngOnInit() {
    this.dropdown = false;
    this.text = [];
    this.compareDates = ['<', '>', '='];
    this.compareOther = ['<', '>', '<>', '='];
    this.isFilterResponse = false;
    this.blobUrl = environment.blobUrl;
    if (this.showAny == undefined)
      this.showAny = true;
  }

  onClickOutside(event: Object) {
    if (event && event['value'] === true) {
      this.dropdown = false;
    }
  }

  toggleDropdown() {
    if (!this.disabled) {
      this.dropdown = true;
    }
  }

  changeLabel(s) {
    if (s == 'Any') {
        this.dropdownLabel = s;
    }
    else {
      if (this.fieldName === undefined || this.fieldName === '') {
        this.dropdownLabel = s;
      } else {
        this.dropdownLabel = s[this.fieldName];
      }
    }
    this.userChoice.emit(s);
    }

    onSaveAnswer(item: any, value: string) {
      switch (this.answerType) {
        case "YesNo": 
          var listItem = item.filter(x => x.answer == value)[0];
          this.dropdownLabel = value.toString();
          this.userChoice.emit(listItem);
          break;
        case "Date": 
          this.dropdownLabel = item.toString();
          this.userChoice.emit(item);
          break;
        case "OpinionScale": case "Rating": case "Number" :
          this.dropdownLabel = item.toString();
          this.userChoice.emit(item);
          break;  
        default: 
            if (item.check) {
              this.text.push(item.answer);
            } else {
              var idx = this.text.indexOf(item.answer);
              if (idx != -1) {
                this.text.splice(idx, 1);
              }
            }
            this.dropdownLabel = "( " +  this.text.length.toString() + " selected )";
          break;
      }
    }  

    filterItem(item, value) {
      return item.filter(x => x.answer == value);
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown-type/dropdown-type.component.ts